import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="min-h-screen bg-bone flex items-center justify-center p-6">
            <div className="text-center">
                <p className="text-xs uppercase tracking-[0.25em] text-ash mb-4">404</p>
                <h1 className="font-serif text-5xl md:text-7xl mb-6">Page not found.</h1>
                <Link to="/" className="inline-block border border-ink px-6 py-3 hover:bg-ink hover:text-bone transition-colors" data-testid="notfound-home">
                    Return home
                </Link>
            </div>
        </div>
    );
}
